import actions from "actions";
import React from "react";
import { connect } from "react-redux";
import { Container } from "reactstrap";
import { useHistory } from "react-router-dom";
import { bindActionCreators, Dispatch } from "redux";
import "./index.scss";

type BreadcrumbProps = {
  data?: Array<any>;
  navigateBreadcrumbs?: Function;
};

const Breadcrumb = ({ data, navigateBreadcrumbs }: BreadcrumbProps) => {
  const history = useHistory();
  if (!data || data?.length == 0) return <div></div>;
  const renderItem = (item: any, index: number) => {
    if (index == data.length - 1)
      return (
        <span className="breadcrumb-container__item-active" key={item.label}>
          {item.label}
        </span>
      );
    return (
      <div className="breadcrumb-container__item" key={item.label}>
        <span
          className="normal-button"
          onClick={() => {
            navigateBreadcrumbs?.(index);
            history.push(item.path);
          }}
        >
          {item.label}
        </span>
        <i className="material-icons">keyboard_arrow_right</i>
      </div>
    );
  };
  return (
    <Container>
      <div className="breadcrumb-container">{data.map(renderItem)}</div>
    </Container>
  );
};

const mapStateToProps = (state: any) => {
  return {
    data: state.breadcrumb.data,
  };
};

const mapActionsToProps = (dispatch: Dispatch) =>
  bindActionCreators(actions, dispatch);

export default connect(mapStateToProps, mapActionsToProps)(Breadcrumb);
